import {React, useEffect } from "react";

const ContactUs = () =>{
    useEffect(() => {
            window.scrollTo(0, 0);
          }, []);
    return (
        <div>
            <div className="container-fluid service-banner">
        <h1>Contact Us</h1>
        <hr/>
        <p>We look forward to hearing from you.</p>
        
        <button style={{borderRadius: "10px", padding: "10px 30px 10px 30px",fontSize: "20px"}}>LOCATIONS <i className="fas fa-arrow-right"></i></button>
    </div>

    

   



    <div className="container-fluid" style={{backgroundImage: "linear-gradient(25deg, #d6c2f0 0%, rgb(255, 255, 255) 70%)",paddingTop: "100px"}}>
        
        <div className="row" style={{paddingTtop:"50px"}}>

            
            <div className="col-md-12" >
                <div className="" >

                    <div className="card-body no-borders">
                        <form>
                            <div className="form-row">
                                <div className="form-group col-md-6">
                                    <label for="name">First name*</label>
                                    <input type="text" className="form-control" id="name" placeholder="Enter your Firstname"/>
                                </div>
                                <div className="form-group col-md-6">
                                    <label for="email">Last Name*</label>
                                    <input type="email" className="form-control" id="email" placeholder="Enter your Last Name"/>
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-group col-md-6">
                                    <label for="phone">Email*</label>
                                    <input type="tel" className="form-control" id="phone"
                                        placeholder="Enter your Email"/>
                                </div>
                                <div className="form-group col-md-6">
                                    <label for="phone">Phone</label>
                                    <input type="tel" className="form-control" id="phone"
                                        placeholder="Enter your phone number"/>
                                    
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-group col-md-12">
                                    <label for="phone">Category</label>
                                    <input type="tel" className="form-control" id="phone"
                                        placeholder="Category"/>
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-group col-md-12">
                                    <label for="message">How Can i help you?</label>
                                    <textarea className="form-control" id="message" rows="3"
                                        placeholder="Your message"></textarea>
                                </div>
                            </div>
                            <p className="policy">shanvatech needs the contact information you provide to us to contact you about our products and services. You may unsubscribe from these communications at any time. For information on how to unsubscribe, as well as our privacy practices and commitment to protecting your privacy, please review our Privacy Policy.</p>
                            
                            <button type="submit" className="formSubmit">Submit</button>
                        </form>


                    </div>
                </div>
            </div>




        </div>
    </div>


   {/*  <div className="container-fluid " style={{paddingTop:"50px"}} >
        
        <div className="row join-us" >

            
            <div className="col-md-9" style={{padding: "20px"}}>
                <div className="" >

                    <h1>Join us</h1>
                    <p>Explore our Careers portal to get connected with career opportunities in your area!</p>
                    <button type="submit" className="formSubmit">CAREERS</button>

                </div>
            </div>
            <div className="col-md-3" >
                <div className="" >

                    <img src="assets/Technology_Consulting_Services.png" style={{width: "300px", height: "200px"}}/>

                </div>
            </div>


        </div>
    </div> */}
        </div>
    )
}

export default ContactUs;